import styled from 'styled-components'

export const CountryWrapper = styled.div`
  width: 50px;
  margin-right: 5px;
`
